import autobind from 'autobind-decorator';
import { Inject, Injectable, forwardRef } from '@kaokei/use-vue-service';
import { drawGoods, getGoodsByWeek } from '~/api/oj/home';
import { getPosterGoodsInfo } from '~/api/oj/community';
import { RouterService } from '~/services/router.service';
import type { GoodsMissionVO } from '~/types/auto/actuator';
import type { PosterSimpleInfoVo } from '~/types/auto/forum';
import { showErrorMsg, showSuccessMsg } from '~/utils/utility';

@Injectable()
export class WeeklyGoodsService {
  public loadingGoodsInfo = false;
  public loading = {
    single: false,
    triple: false
  };
  public goodsInfo: GoodsMissionVO | null = null;
  public ruleInfo = {} as PosterSimpleInfoVo;

  @Inject(forwardRef(() => RouterService))  public routerService!: RouterService;

  init() {
    this.getGoodsByWeek();
    getPosterGoodsInfo().then(res => {
      this.ruleInfo = res;
    })
  }

  setLoading(type: 'single' | 'triple', state: boolean) {
    this.loading[type] = state;
  }

  updateCount(delta: number) {
    if (this.goodsInfo && typeof this.goodsInfo.totalCount === 'number') {
      this.goodsInfo.totalCount = Math.max(0, this.goodsInfo.totalCount + delta);
    }
  }
@autobind
  drawSingleGoods() {
    const count = 1;
    this.loading.single = true;
    return drawGoods(count, this.goodsInfo?.id as number).finally(() => {
      this.loading.single = false;
    });
  }
@autobind
  draw3TimesGoods() {
    const count = 5;
    this.loading.triple = true;
    return drawGoods(count, this.goodsInfo?.id as number).finally(() => {
      this.loading.triple = false;
    });
  }
  @autobind
  getGoodsByWeek({ withLoading = true }: { withLoading?: boolean } = {}) {
    if (withLoading) {
      this.loadingGoodsInfo = true;
    }
    getGoodsByWeek()
      .then((res) => {
        this.goodsInfo = res;
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.loadingGoodsInfo = false;
      });
  }
}
